import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useCommonFragments from '../../../../../../base/hooks/CommonFragments';
import useUserGql from '../../../../../../wedding-wardrobe/src/components/users/hooks/useUserGql';
import useNotificationStateContext from '../../../../../../base/hooks/useNotificationStateContext';

export default () => {
  const { gql, useMutation, useQuery } = useAppContext();
  const { PhoneNumberFragment, AddressFragment, InspirationFragment } = useCommonFragments();
  const { UserFragment } = useUserGql();
  const { triggerNotification } = useNotificationStateContext();


  const AvailabilityBookingFragment = gql`
fragment AvailabilityBookingFragment on Availability {
  id
  from
  to
}
  `;

  const UsersAvailabilityFragment = gql`
fragment UsersAvailabilityBookingFragment on UsersAvailability {
  id
  status
  conciergeOption
  statusTimestamp
  availability {
    ...AvailabilityBookingFragment
  }
  user {
    ...UserFragment
  }
}  
${AvailabilityBookingFragment}
${UserFragment}
  `;
  const AppointmentBookingFragment = gql`
fragment AppointmentBookingFragment on Appointment {
  id
  gid
  appointmentType
  conciergeOption
  dressType
  linkToRoomVisible
  status
  room {
    referenceNumber
  }
  confirmation {
    id
    confirmed
    canceled
  }
  usersAvailability {
    ...UsersAvailabilityBookingFragment
  }
}
${UsersAvailabilityFragment}  
  `;

  const EventBookingFragment = gql`
fragment EventBookingFragment on Event {
  id
  gid
  eventDate
  eventDateFormatted
  budget
  eventTitle
  eventType
  inspirations {
    ...InspirationFragment
  }
}  
  `;

  const ClientBookingFragment = gql`
fragment ClientBookingFragment on Client {
  id  
  email
  firstName
  lastName
  preferredLang
  referral
  dressSize
  bestPhoneNumber {
    id
    ...PhoneNumberFragment
  }
  address {
    id
    ...AddressFragment
  }
  inspirations {
    ...InspirationFragment
  }
  bookingComment {
    id
    text
  }
} 
${PhoneNumberFragment} 
${AddressFragment} 
${InspirationFragment} 
  `;

  const ClientsEventBookingFragment = gql`
fragment ClientsEventBookingFragment on ClientsEvent {
  id
  gid
  roleName
  clientAttributes {
    ...ClientBookingFragment
  }
  event {
    ...EventBookingFragment
  }
  upcomingAppointment {
    ...AppointmentBookingFragment
  }
}  
${ClientBookingFragment}
${EventBookingFragment}
${AppointmentBookingFragment}
  `;

  const ClientsEventBookingMutation = gql`
mutation clientsEventBooking($input: ClientsEventInput!) {
  clientsEventBooking(input: $input) {
    clientsEvent {
      ...ClientsEventBookingFragment
    }
    errors
  }
} 
${ClientsEventBookingFragment}  
  `;

  const NewClientsEventQuery = gql`
query newClientsEventBooking {
  newClientsEvent {
    ...ClientsEventBookingFragment
  }
}  
${ClientsEventBookingFragment}  
  `;

  const ClientsEventBookingNodeQuery = gql`
query nodeClientsEventBooking($gid: ID!) {
  node(gid: $gid) {
    id
    gid
    ... on ClientsEvent {
      ...ClientsEventBookingFragment
    }
  }
}  
${ClientsEventBookingFragment}  
  `;

  const useClientsEventBookingMutation = () => useMutation(ClientsEventBookingMutation, {
    onError(e) {
      triggerNotification(e.message, 'error');
    },
  });

  const useNewClientsEventBookingQuery = () => useQuery(NewClientsEventQuery);

  const useClientsEventBookingNodeQuery = (gid) => useQuery(ClientsEventBookingNodeQuery, {
    variables: { gid },
    fetchPolicy: 'network-only',
  });

  return {
    AppointmentBookingFragment,
    useClientsEventBookingMutation,
    useNewClientsEventBookingQuery,
    useClientsEventBookingNodeQuery,
    ClientsEventBookingMutation,
  };
};
